import { Component, OnDestroy, OnInit } from '@angular/core';
import { ThemeServiceService } from 'src/app/services/theme-service.service';
import { Subject, interval } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-about-me',
  templateUrl: './aboutMe.component.html',
  styleUrls: ['./aboutMe.component.scss']
})
export class AboutMeComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  public logoSrc: string = 'assets/img/logo2-white.png';

  constructor(private themeService: ThemeServiceService) { }

  ngOnInit(): void {
    this.updateLogo();
    
    // Verificar cambios de tema cada 500ms
    interval(500)
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.updateLogo();
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateLogo(): void {
    const currentTheme = this.themeService.getActiveTheme();
    // En modo monocromático (fondo blanco), usar logo negro
    // En otros modos (fondo oscuro), usar logo blanco
    if (currentTheme.name === 'monochrome') {
      this.logoSrc = 'assets/img/logo2-black.png';
    } else {
      this.logoSrc = 'assets/img/logo2-white.png';
    }
  }
}
